export default __webpack_public_path__ + "static/media/clinical-reseachs.c94b6c8c.svg";